import React, { FC } from 'react';
import { Form, InjectedFormProps, reduxForm } from 'redux-form';
import { PublicJobSubscriptionFormValues } from './types';
import TextboxAdapter from '../../../../components/adapters/form/Textbox';
import { email, length } from '../../../../utils/formValidators';
import { FormField } from '../../../../components/CustomForm';
import { useTranslationAPI } from '../../../translations';
import { codes } from '../../../../data/translations';
import { PUBLIC_JOB_SUBSCRIPTION_FORM_NAME } from './const';
import { EnvelopeO } from '../../../../components/Icons/EnvelopeO';
import { IconButton } from '../../../../components/IconButton';
import { FlexGrid, FlexGridColumn } from '../../../../components/FlexGrid';

const PublicJobSubscriptionFormComponent: FC<
	React.PropsWithChildren<InjectedFormProps<PublicJobSubscriptionFormValues>>
> = ({ submitting, handleSubmit }) => {
	const { translate } = useTranslationAPI();

	return (
		<Form onSubmit={handleSubmit}>
			<FlexGrid>
				<FlexGridColumn grow>
					<FormField
						name='email'
						component={TextboxAdapter}
						validate={[email({ allowBlank: true }), length({ max: 128 })]}
						disabled={submitting}
						componentProps={{ placeholder: translate(codes.common.emailExample) }}
					/>
				</FlexGridColumn>
				<IconButton
					primary
					size='small'
					disabled={submitting}
					type={'submit'}
				>
					<EnvelopeO />
				</IconButton>
			</FlexGrid>
		</Form>
	);
};

export const PublicJobSubscriptionForm = reduxForm<PublicJobSubscriptionFormValues>({
	form: PUBLIC_JOB_SUBSCRIPTION_FORM_NAME,
	initialValues: { email: '' },
})(PublicJobSubscriptionFormComponent);
